import React, { Fragment } from 'react';
import {
  Stack, Grid,
  Box,
  Button,
  IconButton,
  Typography,
  InputAdornment,
  Checkbox,
  Radio,
  RadioGroup,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  Popover, 
  Divider,
  Tooltip,
  MenuItem
} from '@mui/material';
import {
  StyledCard, StyledCardTitle,
  TableBadge,
  InputProps,
  CustomCheckbox,
  CustomInputLabel,
  CustomSearch,
  CustomSelectRounded,
  CustomRadio,
  StyledTableContainer,
  FlexDiv,
  CustomDateTimePicker,
  CustomDatePicker,
  PopoverContent,
  SelectInputProps
} from '../../../custom/components';
import { AddIcon, DateFormat, DeleteIcon, DocIcon, DownloadIcon, EditIcon } from '../../../custom/constants';
import notificationStyles from './notification.module.css';
import styles from '../../../custom/style.module.css';
import SendIcon from '../../../assets/images/actionIcons/paperPlane.svg';
import { ArrowLeft, ArrowRight, Clear, KeyboardArrowDown, KeyboardArrowUp, PersonPinCircle, Search } from '@mui/icons-material';
import AddHouseAwbModal from './AddHouseAwbModal';
import UpdateConsigneeModal from './UpdateConsigneeModal';
import AddAdditionalServicesModal from './AddAdditionalServicesModal';
import Slider from 'react-slick';
import SendNotificationModal from './SendNotificationModal';
import NotificationHistoryModal from './NotificationHistoryModal';
// import dummyPDF from '../../../assets/images/dummyPDF.pdf';
import ZoomIn from '../../../assets/images/actionIcons/zoomIn.svg';
import ZoomOut from '../../../assets/images/actionIcons/zoomOut.svg';
import PartArrivalInfo from './PartArrivalInfo';
import AddDocModal from './AddDocModal';
import PDFSlider from './PDFSlider';
import calculateFees, { getFee } from 'utils/feeCalculator';
import environment from '../../../custom/environments';
import { getAwbDetails } from 'utils/import';
import moment from 'moment';
import { grey } from '@mui/material/colors';
import cookies from 'utils/cookies';
import dayjs from 'dayjs';
import RequestStatusIcon from '../../../assets/images/actionIcons/requestStatus.svg';
import NFDRequestIcon from '../../../assets/images/actionIcons/NFDRequest.svg';
import RefreshIcon from '../../../assets/images/actionIcons/refresh.svg';

const timezone = cookies.get('timezone') || null;
const CUSTOMS_STATUS_NOT_AVAILABLE = 'Customs Status not available';

const STACKFILTER = {
  direction: {
    xs: 'column',
    lg: 'row',
  },
  align: {
    xs: 'flex-start',
    lg: 'center',
  }
};

const NextArrow = (props) => {
  const { newClass, onClick, currentSlide, slideCount } = props;
  const isDisabled = currentSlide + 2 === slideCount;

  return (
    <IconButton
      aria-label='Next'
      onClick={onClick}
      className={newClass}
      classes={{ root: notificationStyles.sliderRightArrow }}
      disableRipple
      size='small'
      disabled={isDisabled}
      color='secondary'
    >
      <ArrowRight fontSize='inherit' />
    </IconButton>
  );
};

const PrevArrow = (props) => {
  const { newClass, onClick, currentSlide } = props;
  const isDisabled = currentSlide === 0;
  return (
    <IconButton
      aria-label='Prev'
      onClick={onClick}
      className={newClass}
      classes={{ root: notificationStyles.sliderLeftArrow }}
      disableRipple
      size='small'
      disabled={isDisabled}
      color='secondary'
    >
      <ArrowLeft fontSize='inherit' />
    </IconButton>
  );
};

const settings = {
  infinite: false,
  dots: false,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

const disablefields = /*cookies.get('role') === 'Airline Rep' ||*/ cookies.get('role') === 'GHA Agent' ? true : false;

const ImportNotification = (props) => {

  const pageUrl = window && window.location.pathname.includes('/flight_folder/import_notification');
  
  // const customStatusRequestCount = (props.importAwbs || []).filter(
  //   (awb) => awb.custom_status?.status?.length > 0
  // ).length;
  // const hasPendingCustomStatus = customStatusRequestCount > 0;
  // const requestCustomStatusDisabled = (props?.flightTab && hasPendingCustomStatus) || disablefields;


  const hasClearedCustoms = (awb) => {
    const customStatusList = awb.custom_status?.status || [];
    const houseStatusList = awb.custom_status?.house_status || [];
    const latestStatus = customStatusList[customStatusList.length - 1];
    let cleared = false;
    if(latestStatus && props.customStatusCodes?.marked_as_cleared?.includes(latestStatus?.dispositionCode)) {
      cleared = true;
    } else if(houseStatusList && houseStatusList.length > 0) {
      houseStatusList.forEach((houseStatus) => {
        const latestHouseStatus = houseStatus?.dispositionMsg?.[houseStatus?.dispositionMsg?.length - 1];
        if(latestHouseStatus && props.customStatusCodes?.marked_as_cleared?.includes(latestHouseStatus?.dispositionCode)) {
          cleared = true;
        }
      });
    }
    return cleared;
  };

  const codeStatus = (code) =>{
    let codeStatus = 'customCodeDefault';
    codeStatus = props.customStatusCodes?.marked_as_cleared?.includes(code)
      ? 'customCodeCleared'
      : props.customStatusCodes?.marked_as_not_cleared?.includes(code)
        ? 'customCodeNotCleared'
        : 'customCodeDefault';
    return codeStatus;
  };

  const airlineFilteredAwbs = props.allImportAwbs?.filter((awb) => {
    const airline = props.searchFilters?.airline;
    return airline ?  (airline === awb.flight?.airline?.code) : awb;
  });

  const customsClearedCount = (airlineFilteredAwbs || []).filter(hasClearedCustoms).length;

  const missingClearanceCount = (airlineFilteredAwbs || []).filter((awb) => !hasClearedCustoms(awb)).length;
  

  const bouncedNotificationsCount = (airlineFilteredAwbs || []).reduce(
    (count, awb) => count + ((awb.notifications || []).reduce((c, notification) => {
      const mails = notification?.mail || [];
      console.log('notification mails', mails, mails.filter((mail) => mail.status !== 'pending' && mail.status !== 'delivered').length);
      return c + mails.filter((mail) => mail.status !== 'pending' && mail.status !== 'delivered').length > 0 ? 1 : 0;
    }, 0)),
    0
  );

  const disableRequestCustomStatus = !(props.importAwbs?.length > 0 && props.importAwbs.some(awb => !awb?.custom_status?.req_status)) || !((props?.importAwbs?.length > 0 && props.customStatus?.find((status) => status?.airlineId === props.importAwbs[0]?.flight?.airlineId)?.value) || false);
  const disableRequestNFDStatus = !(props.importAwbs?.length > 0 && props.importAwbs.some(awb => !awb.nfd_requested)) || !((props?.importAwbs?.length > 0 && props.scraper?.find((status) => status?.airlineId === props.importAwbs[0]?.flight?.airlineId)?.value) || false);

  const getTotal = () => {
    let stn = cookies.get('station_code');
    if (stn) {
      let count = (airlineFilteredAwbs || []).filter(awb => awb.flight_awbs?.length > 0).length || 0;
      return <Box display='flex' alignItems='center' flexWrap='wrap' columnGap={1}>
        <CustomRadio
          control={
            <Radio inputProps={{ 'aria-label': 'show total awb', }}
              name='awbType'
              disableRipple
              checked={(props.filter?.awbType || 'total') === 'total'}
              value='total'
              onChange={props.onChangeFilter}
            />
          }
          className={styles.mr0}
          label={<Typography variant='body2' color='primary'>Total</Typography>}
          labelPlacement='end'
        />
        <b className={notificationStyles.count}>{count}</b>
      </Box>;
    }
    return '';
  };
  const getLocal = () => {
    let stn = cookies.get('station_code');
    if (stn) {
      let count = (airlineFilteredAwbs || []).filter(awb => awb.flight_awbs?.[0]?.dest === stn).length || 0;
      return <Box display='flex' alignItems='center' flexWrap='wrap' columnGap={1}>
        <CustomRadio
          control={
            <Radio inputProps={{ 'aria-label': 'show local awb', }}
              name='awbType'
              disableRipple
              checked={props.filter?.awbType === 'local'}
              value='local'
              onChange={props.onChangeFilter}
            />
          }
          className={styles.mr0}
          label={<Typography variant='body2' color='primary'>Local </Typography>}
          labelPlacement='end'
        />
        <b className={notificationStyles.count}>{count}</b>
      </Box>;
    }
    return '';
  };

  const getTransit = () => {
    let stn = cookies.get('station_code');
    if (stn) {
      let count = (airlineFilteredAwbs || []).filter(awb => awb.flight_awbs?.[0]?.dest !== stn).length || 0;
      return <Box display='flex' alignItems='center' flexWrap='wrap' columnGap={1}>
        <CustomRadio
          control={
            <Radio inputProps={{ 'aria-label': 'show transit awb', }}
              name='awbType'
              disableRipple
              checked={props.filter?.awbType === 'transit'}
              value='transit'
              onChange={props.onChangeFilter}
            />
          }
          className={styles.mr0}
          label={<Typography variant='body2' color='primary'>Transit</Typography>}
          labelPlacement='end'
        />
        <b className={notificationStyles.count}>{count}</b>
      </Box>;
    }
    return '';
  };

  const DocViewer = <StyledCard className={`${styles.h100} ${styles.positionRelative} ${notificationStyles.accordionDocViewer}`}
    sx={{
      margin: 'auto',
      width: {
        xs: 400,
        lg: 600,
        xl: '100%',
      },
    }}
  >
    <Box className={`${styles.fSpaceBtw} ${styles.mb2}`} >
      <FlexDiv><StyledCardTitle>Document Viewer</StyledCardTitle></FlexDiv>
      <Stack direction='row' alignItems={'center'} justifyContent='flex-end' mb={2} mt={'-36px'}>
      </Stack>
      <Stack direction='row' spacing={2}>
        <Typography variant='body2' color={'primary'}>{props.scale != 1 ? (Math.round(props.scale * 100) + '%') : ''}</Typography>
        <IconButton size='small' title='Zoom In' onClick={props.zoomIn} className={`${notificationStyles.docIcon} ${styles.p0}`}>
          <img src={ZoomIn} alt='zoom in' />
        </IconButton>
        <IconButton size='small' title='Zoom Out' onClick={props.zoomOut} className={`${notificationStyles.docIcon} ${styles.p0}`}>
          <img src={ZoomOut} alt='zoom out' />
        </IconButton>
        <DownloadIcon className={notificationStyles.docIcon} onClick={props.downloadDoc} title='Download Document' />
        <DocIcon className={notificationStyles.docIcon} />
        <AddIcon title='Add Document' className={`${notificationStyles.docIcon}`} onClick={() => props.handleOpen('add_doc')} disabled={disablefields} />
      </Stack>
    </Box>
    <RadioGroup row aria-labelledby='' name='' id='' value={props.activeDoc}
      onChange={props.selectDoc}
      // onChange={(event) => {
      //   const selectedItem = props.docList.find(item => item.id == event.target.value);
      //   props.selectDoc(event, selectedItem);
      // }} 
      className={`${(props.docList.length > 0 || props.activeAWB?.notifications?.length > 0) ? notificationStyles.docTypeSlider : styles.w100}`}
    >
      <Slider {...settings} className={`${notificationStyles.docRadioSlider}`}>
        {
          props.docList.map((item, index) => (
            <CustomRadio
              key={index}
              control={<Radio size='small' color='success' className={notificationStyles.docTypeRadio} />}
              value={item.id}
              label={item.type == 'AWB' ? 'Airwaybill' : item.name}
              classes={{
                root: notificationStyles.sliderRadioRoot,
                label: notificationStyles.sliderLabel
              }}
            />
          ))
        }
        {props.activeAWB?.notifications &&
          [...props.activeAWB.notifications].reverse().map((item, index) => (
            <CustomRadio
              key={index + props.docList.length}
              control={<Radio size='small' color='success' className={notificationStyles.docTypeRadio} />}
              value={'n' + item.id}
              label={`${index + 1}${index == 0 ? 'st' : index == 1 ? 'nd' : index == 2 ? 'rd' : 'th'} Arrival Notification`}
              classes={{
                root: notificationStyles.sliderRadioRoot,
                label: notificationStyles.sliderLabel,
              }}
            />
          ))}
      </Slider>
    </RadioGroup>

    {props.viewPreview && props.viewPreview.split('.')[1] === 'pdf' ?
      <PDFSlider file={environment.apiService + 'document?key=' + props.viewPreview} className={styles.mauto} scale={props.scale} />
      :
      <div className={notificationStyles.placeholderText}>
        <div className={`${styles.fMiddle} ${styles.fColumn}`}>
          <Typography component={'h5'} variant={'h5'} color='primary'>Document Preview Window</Typography>
          <Typography component={'span'} variant={'caption'} color='text.secondary'>Please add a document to preview</Typography>
        </div>
      </div>}
  </StyledCard>;

  return (
    <>
      {!props?.flightTab && <div
        className={`${styles.wAuto} ${styles.headerFieldContainer} ${notificationStyles.headerWraperTop}`}>
        <StyledCard className={`${notificationStyles.filterCard}`}>
          <StyledCardTitle gutterBottom className={`${notificationStyles.filterTitle}`}>Filter Flights</StyledCardTitle>
          <Grid container columnSpacing={{
            xs: 4,
            lg: 2,
            xl: '2%'
          }} rowSpacing={{
            xs: 2,
            lg: 0,
          }} justifyContent={{
            xs: 'flex-start',
            xl: 'center',
          }}>
            <Grid item xs={12} sm={6} md={12/5} lg={'auto'} display='flex' alignItems='flex-end'>
              <CustomSelectRounded
                {...SelectInputProps}
                id='airline'
                labelId='airline-label'
                fullWidth
                autoFocus
                onChange={props.onChangeSearch}
                name='airline'
                value={!props?.searchFilters?.airline ? false : props.searchFilters.airline}
                renderValue={(selected) => {
                  if (selected === false) return 'All';
                  if (!selected || selected === 'placeholder') return 'Select Airline';
                  return selected;
                }}
                sx={{ minWidth: '150px' }}
                classes={{ select: props?.searchFilters?.airline === 'placeholder' ? styles.colorPlaceholder : '' }}
              >
                <MenuItem value='placeholder' disabled >Select Airline</MenuItem>
                <MenuItem value={false} >All</MenuItem>
                {props?.airlines?.map((airline, i) => (
                  <MenuItem key={i} value={airline.code}>
                    {airline.code} - {airline.name}
                  </MenuItem>
                ))}
              </CustomSelectRounded>
            </Grid>
            <Grid item xs={12} sm={6} md={12/5} xl={'auto'} display='flex' alignItems='flex-end' maxWidth={{ xl: 230 }}>
              <CustomSearch
                {...InputProps}
                id='awb'
                placeholder='Enter Airwaybill Number'
                type='search'
                name='flight_no'
                value={props.search}
                onChange={props.onChangeSearch}
                InputProps={{
                  disableUnderline: true,
                  endAdornment: <InputAdornment position='end'>
                    <IconButton
                      size='small'
                      aria-label='search'
                      edge='end'
                      disabled={props.searchFilters?.start_date || props.searchFilters?.end_date}
                    >
                      <Search fontSize='inherit' onClick={() => props.onChangeSearch({
                        target: {
                          name: 'search_click',
                          value: props.search
                        }
                      })} />
                    </IconButton>
                  </InputAdornment>,
                }}
                className={`${styles.brInput} ${styles.w100}`}
                disabled={props.searchFilters?.start_date || props.searchFilters?.end_date}
              />
            </Grid>
            <Grid item xs='auto' sx={{ '@media (max-width: 900px)': { display: 'none', } }}>
              <Divider orientation='vertical' variant='middle' flexItem sx={{
                backgroundColor: '#ffffff8f',
                height: '100%',
              }} />
            </Grid>
            <Grid item xs={12} sm md={12/5} lg={3} xl maxWidth={{ xl: 230 }}>
              <Stack direction={{
                xs: 'column',
                lg: 'row',
              }}
              align={{
                xs: 'flex-start',
                lg: 'center',
              }}>
                <CustomInputLabel htmlFor='' aria-label='Enter from date' className={`${styles.ipLabel}`}>From</CustomInputLabel>
                <CustomDatePicker
                  slotProps={{
                    textField: {
                      ...InputProps,
                      id: 'start-date',
                      placeholder: 'Start Date',
                      fullWidth: true,
                    },
                    field: { clearable: true },
                  }}
                  format={'DD MMM YY'}
                  onChange={(v) => props.onChangeSearch({
                    target: {
                      name: 'start_date',
                      value: v ? dayjs(v).format('YYYY-MM-DD') : null
                    }
                  })}
                  value={props.searchFilters?.start_date ? dayjs(props.searchFilters.start_date) : null}
                  className={`${styles.brInput} ${notificationStyles.filterDatePicker}`}
                  disabled={props.search}
                />
              </Stack>
            </Grid>
    
            <Grid item xs={12} sm md={12/5} lg={3} xl maxWidth={{ xl: 230 }}>
              <Stack {...STACKFILTER}>
                <CustomInputLabel htmlFor='end-date' aria-label='Enter to date' className={`${styles.ipLabel}`}>To</CustomInputLabel>
                <CustomDatePicker
                  slotProps={{
                    textField: {
                      ...InputProps,
                      id: 'end-date',
                      placeholder: 'End Date',
                      fullWidth: true,
                    },
                    field: { clearable: true },
                  }}
                  format={'DD MMM YY'}
                  onChange={(v) => props.onChangeSearch({
                    target: {
                      name: 'end_date',
                      value: v ? dayjs(v).format('YYYY-MM-DD') : null
                    }
                  })}
                  value={props.searchFilters?.end_date ? dayjs(props.searchFilters.end_date) : null}
                  className={`${styles.brInput} ${notificationStyles.filterDatePicker}`}
                  disabled={props.search}
                />
              </Stack>
            </Grid>
            <Grid item xs='auto' className={styles.pl2} minWidth={'40px'}>
              {(props.searchFilters?.start_date || props.searchFilters?.end_date) &&
              <IconButton title='Clear Filter' color='default' onClick={props.onResetFilters} size='small'  
                className={`${notificationStyles.clearFilter}`}>
                <Clear fontSize={'12px'} />
              </IconButton>
              }
            </Grid>
          </Grid>
        </StyledCard>
      </div>}

      <Grid container spacing={3} sx={{ marginTop: !pageUrl ? '-24px' : (props.showRejectedMessage || props.showNilMessage ? '-24px' : '-48px') }}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={8}>
          <StyledCard className={styles.h100}>
            <Grid container spacing={0.2}>
              <Grid item xs lg={12} order={1}>
                <StyledCardTitle component='div' gutterBottom className={styles.mb0}>Airwaybills</StyledCardTitle>
              </Grid>
              <Grid item xs={12} lg order={{
                xs: 3,
                lg: 2 
              }} 
              >
                <Grid container columnGap={{
                  xs: 2,
                  xl: 2 
                }} alignItems='center' justifyContent={{ xs: 'flex-start' }} mt={'-10px'} mb={2}>
                  <Grid item xs='auto' >
                    <Stack direction='row' alignItems='center' flexWrap='wrap' columnGap={2}>
                      {getTotal()}
                      {getLocal()}
                      {getTransit()}
                    </Stack>
                  </Grid> 
                  <Grid item xs='auto' >
                    <Divider orientation='vertical' flexItem sx={{ height: '30px' }} />
                  </Grid> 
                  {/* {!props?.flightTab &&
              <CustomCheckbox
                control={
                  <Checkbox inputProps={{ 'aria-label': 'hide customs cleared awbs', }}
                    name='noCustomsClearance'
                    disableRipple
                    checked={props.searchFilters?.noCustomsClearance || false}
                    value={props.searchFilters?.noCustomsClearance || false}
                    onChange={props.onChangeSearch}
                  />
                }
                label='Missing clearance'
                className={notificationStyles.checkboxLabel}
              />
                  } */}
                  <Grid item xs='auto'>
                    <Stack direction='row' columnGap={2} alignItems='center'>
                      <Box display='flex' alignItems='center' flexWrap='wrap' columnGap={1}>
                        <CustomCheckbox
                          control={
                            <Checkbox inputProps={{ 'aria-label': 'customs cleared', }}
                              name='customsCleared'
                              disableRipple
                              checked={props.filter?.customsCleared || false}
                              onChange={props.onChangeFilter}
                              disabled={props.filter?.bouncedNotifications || false}
                            />
                          }
                          label='Customs Cleared'
                          className={styles.mr0}
                        />
                        <b className={notificationStyles.count}>{customsClearedCount}</b>
                      </Box>
                      <Box display='flex' alignItems='center' flexWrap='wrap' columnGap={1}>
                        <CustomCheckbox
                          control={
                            <Checkbox inputProps={{ 'aria-label': 'hide customs cleared awbs', }}
                              name='noCustomsClearance'
                              disableRipple
                              checked={props.filter?.noCustomsClearance || false}
                              onChange={props.onChangeFilter}
                              disabled={props.filter?.bouncedNotifications || false}
                            />
                          }
                          label='Missing Clearance'
                          className={styles.mr0}
                        />
                        <b className={notificationStyles.count}>{missingClearanceCount}</b>
                      </Box>
                    </Stack>
                  </Grid>
                  <Grid item xs='auto' >
                    <Tooltip title='Ensure all eligible customs codes are configured in Admin. Only configured codes are included in Customs Cleared filter; all others appear under Missing Clearance.' placement='top' arrow>
                      <span><code className={styles.infoIcon}> i </code></span>
                    </Tooltip>
                  </Grid> 
                  <Grid item xs='auto' >
                    <Divider orientation='vertical' flexItem sx={{ height: '30px' }} />
                  </Grid> 
                  <Grid item xs='auto' >
                    <Stack direction='row' alignItems='center' flexWrap='wrap' rowGap={1} columnGap={1}>
                      <>
                        <CustomCheckbox
                          control={
                            <Checkbox inputProps={{ 'aria-label': 'bounced notifications', }}
                              name='bouncedNotifications'
                              disableRipple
                              checked={props.filter?.bouncedNotifications || false}
                              onChange={props.onChangeFilter}
                            />
                          }
                          label='Bounced Notifications'
                          className={styles.mr0}
                        />
                        <b className={notificationStyles.count}>{bouncedNotificationsCount}</b>
                      </>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
              {props?.flightTab &&
                <Grid item xs='auto' lg='auto' xl='auto' order={{
                  xs: 2,
                  xl: 3 
                }}>
                  <Stack direction='row' spacing={1} alignItems='center' mt={{
                    xs: 0,
                    lg: '-20px' 
                  }} mb={2} ml={2}>
                    <IconButton title='Request Customs Status' color='primary' onClick={() => props.handleCustomStatus(false)} size='small' disableRipple 
                      disabled={disableRequestCustomStatus} 
                      className={`${notificationStyles.customStatusButton} ${styles.p0} ${disableRequestCustomStatus ? styles.disabledIconImg : ''}`}> 
                      <img src={RequestStatusIcon} alt='Request Status' width={26} />
                      <Typography variant='inherit' className={notificationStyles.customStatusButtonName}>Request <br /> Customs Status</Typography>
                    </IconButton>
                    <IconButton title='Request NFD Status' color='primary' onClick={() => props.handleNFDStatus(null)} size='small' disableRipple
                      disabled={disableRequestNFDStatus} 
                      className={`${notificationStyles.customStatusButton} ${styles.p0} ${disableRequestNFDStatus ? styles.disabledIconImg : ''}`}> 
                      <img src={NFDRequestIcon} alt='Request Status' width={26} />
                      <Typography variant='inherit' className={notificationStyles.customStatusButtonName}>{props.nfdProcessing ? 'Processing...' : <span>Request <br /> NFD Status</span>}</Typography>
                    </IconButton>
                  </Stack>
                </Grid>
              }
            </Grid>

            <StyledTableContainer className={notificationStyles.collapsibleTableContainer}>
              <Table aria-label='collapsible table' className={notificationStyles.collapsibleTable}>
                <TableHead className={notificationStyles.collapsibleTableHead}>
                  <TableRow className={notificationStyles.collapsibleHeadRow}>
                    <TableCell className={`${notificationStyles.collapsibleTableCell}`} />
                    <TableCell className={`${notificationStyles.collapsibleTableCell}`}>
                      <Stack direction='row' spacing={2} alignItems='center' justifyContent='flex-start' className={notificationStyles.headerSearchFormControl}>
                        <Typography variant='inherit'>Airwaybill</Typography>
                        <CustomSearch
                          {...InputProps}
                          id='awb'
                          placeholder='Search AWB#'
                          type='search'
                          name='awb_no'
                          value={props.filter?.awb}
                          onChange={props.onChangeFilter}
                          className={`${styles.brInput} ${notificationStyles.headerSearch}`}
                          sx={{ width: 180 }}
                          InputProps={{
                            disableUnderline: true,
                            classes: { input: notificationStyles.headerSearchInput },
                            endAdornment: <InputAdornment position='end'>
                              <IconButton
                                size='small'
                                aria-label='search'
                                edge='end'
                              >
                                <Search fontSize='inherit' />
                              </IconButton>
                            </InputAdornment>,
                          }}
                        />
                      </Stack>
                    </TableCell>
                    <TableCell className={`${notificationStyles.collapsibleTableCell}`}></TableCell>
                    <TableCell className={`${notificationStyles.collapsibleTableCell}`}>Storage Starts</TableCell>
                    <TableCell className={`${notificationStyles.collapsibleTableCell}`}>
                      <Stack direction='row' spacing={1} alignItems='center' justifyContent='space-between'>
                        <Typography variant='inherit'>Fee</Typography>
                        <Typography variant='inherit'>Amount</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell className={`${notificationStyles.collapsibleTableCell}`}></TableCell>
                    <TableCell className={`${notificationStyles.collapsibleTableCell}`}> Consignee / Notify Party</TableCell>
                    <TableCell className={`${notificationStyles.collapsibleTableCell}`}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={notificationStyles.collapsibleTableBody}>
                  {props.importAwbs?.map((row, index) => {
                    const awbData = getAwbDetails(row);
                    const fees = calculateFees(row?.fee || [], awbData);
                    const customStatusList = row.custom_status?.status || [];
                    const house_status = row?.custom_status?.house_status || [];
                    // Sort house statuses to have items with customs status code displayed first.
                    const sortedHouseStatus = [...house_status].sort((first, second) => {
                      const firstIsPending = !first?.dispositionMsg?.[0]?.dispositionCode;
                      const secondIsPending = !second?.dispositionMsg?.[0]?.dispositionCode;
                      return Number(firstIsPending) - Number(secondIsPending);
                    });
                    const firstPendingHouseStatusIndex = sortedHouseStatus.findIndex(
                      (item) => !item?.dispositionMsg?.[0]?.dispositionCode
                    );

                    const latestCustomStatus = customStatusList[customStatusList.length - 1];
                    const isCustomsDisabled = !(props.customStatus?.find((status) => status?.airlineId === row?.flight?.airlineId)?.value || false);
                    const isNFDDisabled = !(props.scraper?.find((status) => status?.airlineId === row?.flight?.airlineId)?.value || false);
                    const latestCustomStatusDateTime = latestCustomStatus
                      ? moment(
                        `${latestCustomStatus?.dispositionActionDate || ''} ${latestCustomStatus?.dispositionActionTime || ''}`,
                        'MMDDYY HHmmss'
                      ).format('DDMMMYY HH:mm:ss').toUpperCase()
                      : '';
                    let storage_start = null;
                    if (row?.fee && row?.fee.length > 0) {
                      let storage = null;
                      row?.fee.forEach((fee) => {
                        fee?.value?.forEach((value) => {
                          if (value.unit === 'kg_per_day') {
                            storage = value;
                          }
                        });
                      });
                      if (storage) {
                        let storgae_info = getFee(storage, row?.fee, awbData, true);
                        storage_start = storgae_info?.storage_start || null;
                      }
                    }
                    return <Fragment key={index}>
                      <TableRow key={index} className={notificationStyles.collapsibleTableRow} onClick={() => { props.activeAWB?.id !== row?.id ? props.fetchDocs(row) : null; }}>
                        <TableCell ref={props.columnRef.radio_btn} style={{ width: props.columnWidth?.radio_btn }} className={notificationStyles.collapsibleTableCell} >
                          <Radio size='small' className={styles.p0}
                            checked={props.activeAWB?.id === row?.id}
                          />
                          <IconButton
                            aria-label='expand row'
                            size='small'
                            onClick={() => props.handleTableCollapse(row.id, row)}
                            disabled={props.activeAWB?.id != row?.id}
                            className={notificationStyles.docViewerTabView}
                            sx={{ display: { xl: 'none' } }}
                          >
                            {props.collapseViewer.includes(row.id) ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                          </IconButton>
                        </TableCell>
                        <TableCell ref={props.columnRef.awb_no} style={{
                          width: props.columnWidth?.awb_no,
                          maxWidth: 'auto',
                        }} className={notificationStyles.collapsibleTableCell} >
                          <Stack direction='column' spacing={1} alignItems='flex-start'>
                            <Typography variant='inherit'>{`${awbData.awb_no} | ${awbData.part ? `${awbData.pcs}/${awbData.total_pcs}` : awbData.pcs}Pcs | ${awbData.wgt}K | ${awbData.org} - ${awbData.dest}`}
                              {row.flight_awbs?.[0]?.dest !== cookies.get('station_code') &&
                                <Typography variant='inherit' className={notificationStyles.transit}>Transit</Typography>}
                            </Typography>
                            {!props.flightTab && <Typography variant='inherit' whiteSpace={'break-spaces'}><b>Flight:</b> {row.flight?.airline?.code}{row.flight?.flight_no}/{moment(row.flight?.flight_date).format('DDMMMYY').toUpperCase()}</Typography>}
                            <Stack direction='row' alignItems='center'>
                              <Typography variant='inherit' whiteSpace={'break-spaces'} fontWeight={'bold'}>Commodity: </Typography>
                              <Typography variant='inherit' flexWrap='wrap'>{awbData.remark}</Typography>
                            </Stack>
                            <Stack direction='row' alignItems='flex-start' >
                              <Typography variant='inherit' whiteSpace={'break-spaces'} fontWeight={'bold'}>SPL: </Typography>
                              <Typography variant='inherit' flexWrap='wrap' maxWidth='100%' whiteSpace='wrap'>{awbData?.spl_code?.split(',').join(', ')}</Typography>
                            </Stack>
                            <Stack direction='row' spacing={1} alignItems='center'>
                              {latestCustomStatus ? <Typography variant='inherit' color='primary' className={`${notificationStyles.customStatus} ${notificationStyles.customCode} ${notificationStyles[codeStatus(latestCustomStatus.dispositionCode)]}`}>
                                {latestCustomStatus.dispositionCode} - {latestCustomStatusDateTime}
                              </Typography> : <Typography variant='inherit' color='textSecondary' textTransform='uppercase' className={`${notificationStyles.customStatus} ${notificationStyles.noCustomStatus} ${notificationStyles.customCode}`}>
                                {CUSTOMS_STATUS_NOT_AVAILABLE}
                              </Typography>}
                              {(latestCustomStatus || (house_status && house_status.length > 0) ) && (<Button size='small'
                                title='History'
                                variant='contained'
                                color='primary'
                                className={styles.historyIcon}
                                onClick={(e) => props.handlePopoverOpen('status_history', e.currentTarget, [
                                  ...(row.custom_status?.status || []),
                                  ...((row.custom_status?.house_status || [])
                                    .flatMap((item) =>
                                      (item?.dispositionMsg || []).map((msg) => ({
                                        ...msg,
                                        hawbNumber: item?.hawbNumber || null,
                                      }))
                                    )),
                                ])}
                                disableElevation
                                disableRipple
                              >H
                              </Button>)}
                              {(latestCustomStatus || (house_status && house_status.length > 0) ) && (
                                <IconButton 
                                  title='Download Status Report' 
                                  onClick={() => props.downloadCustomStatusReport(row)} 
                                  className={`${notificationStyles.customDocIcon}`}
                                  disableRipple
                                >
                                  <DownloadIcon title='' />
                                </IconButton>)}
                              {(() => {
                                const lastRequestTime = latestCustomStatus?.last_request_time;
                                if (!lastRequestTime) {
                                  return false;
                                }
                                const cronDate = moment
                                  .utc(lastRequestTime)
                                  .add(props.cron_period, 'days');
                                const currentDate = moment().tz(timezone);

                                console.log(
                                  'Cron date',
                                  cronDate.clone().tz(timezone).format('YYYY-MM-DD HH:mm:ss')
                                );
                                console.log(
                                  'Current date',
                                  currentDate.format('YYYY-MM-DD HH:mm:ss')
                                );

                                return cronDate.isBefore(currentDate);
                              })() || !latestCustomStatus && (
                                <IconButton 
                                  title='Request Customs Status' 
                                  onClick={() => props.handleCustomStatus(row.id)}
                                  className={`${notificationStyles.customDocIcon}`}
                                  disabled={isCustomsDisabled}
                                  disableRipple
                                  color='primary'
                                  classes={{ disabled: styles.disabledImg }}
                                >
                                  <img src={RefreshIcon} alt='Refresh' />
                                </IconButton>
                              )}
                            </Stack>
                            {house_status && house_status.length > 0 && 
                              <Stack direction='row' spacing={1} rowGap={1} alignItems='center' flexWrap='wrap' className={notificationStyles.hawbStatusWrapper}>
                                {sortedHouseStatus.map((item, index) => {

                                  return (<Fragment key={index}>
                                    {index === firstPendingHouseStatusIndex && <Typography variant='inherit' color='textSecondary' component='div' pt={2} sx={{ flexBasis: '100%' }}>
                                      {CUSTOMS_STATUS_NOT_AVAILABLE} for the below HAWB(s)
                                    </Typography>}
                                    <Typography variant='inherit' color='primary' className={`${notificationStyles.customStatus} ${notificationStyles.customCode} ${notificationStyles.hawbCustomCode} ${notificationStyles[codeStatus(item.dispositionMsg?.[0]?.dispositionCode)]}`}>
                                      {`HAWB-  ${item.hawbNumber}  ${item.dispositionMsg?.[0]?.dispositionCode ? `- ${item.dispositionMsg?.[0]?.dispositionCode}` : ''}`}
                                    </Typography>
                                  </Fragment>);
                                })}
                              </Stack>
                            }
                            {row.nfd_date ? <Typography variant='inherit' color='primary'  className={`${notificationStyles.customStatus} ${notificationStyles.nfdCode}`}>
                                  NFD - {moment.utc(row.nfd_date).format('DDMMMYY HH:mm:ss').toUpperCase()}
                            </Typography> : 
                              <Stack direction='row' spacing={1} alignItems='center'>
                                <Typography variant='inherit' color='textSecondary' textTransform='uppercase' className={`${notificationStyles.customStatus} ${notificationStyles.noCustomStatus} ${notificationStyles.nfdCode}`}>
                                NFD - Pending 
                                </Typography>
                                <IconButton 
                                  title='Request NFD Status' 
                                  onClick={() => props.handleNFDStatus(row.id)}
                                  className={`${notificationStyles.customDocIcon}`}
                                  disableRipple
                                  color='primary'
                                  disabled={isNFDDisabled}
                                  classes={{ disabled: styles.disabledImg }}
                                >
                                  <img src={RefreshIcon} alt='Refresh' />
                                </IconButton>
                              </Stack>
                            }

                            {awbData.part && (<Button className={notificationStyles.partInfoBtn} onClick={(e) => props.handleOpen('part_arrival_info', e.currentTarget, {
                              id: row?.id,
                              parts: awbData.parts,
                              next: row.next
                            })}>Part Info</Button>)}
                          </Stack>
                        </TableCell>
                        <TableCell align='center' ref={props.columnRef.add_icon}
                          style={{ width: props.columnWidth?.add_icon }}
                          className={`${notificationStyles.collapsibleTableCell} ${notificationStyles.smallIcon}`}>
                          {!row.house_awb === true &&
                            <AddIcon title='Add house airwaybill' onClick={() => props.handleOpen('add_house_awb', null, row)} disabled={props.showReportModal || disablefields} className={styles.pt1} />
                          }
                        </TableCell>
                        <TableCell align='center' ref={props.columnRef.storage_start} style={{
                          width: props.columnWidth?.storage_start,
                          minWidth: 140
                        }}
                        className={notificationStyles.collapsibleTableCell}>
                          {/* {storage_start ? moment(storage_start).format(DateFormat).toUpperCase() : ''} */}
                          <CustomDateTimePicker
                            slotProps={{
                              textField: {
                                ...InputProps,
                                placeholder: 'Storage Start',
                                fullWidth: true
                              },
                              openPickerIcon: PersonPinCircle,
                            }}
                            format={'DD MMM YY'}
                            // onClose={() => props.onEditField('')}
                            onAccept={(v) => props.onStorage(row, moment(v.$d).format('YYYY-MM-DD HH:mm:ss'))}
                            value={storage_start ? dayjs(storage_start) : null}
                            disabled={disablefields}
                          />
                        </TableCell>
                        <TableCell ref={props.columnRef.fee} style={{ width: props.columnWidth?.fee }} className={notificationStyles.collapsibleTableCell}>
                          <Stack direction='column' spacing={1} alignItems='flex-start'>
                            {fees.services.map((item, index) => {
                              let lable = '';
                              if (item.additional_info && item.additional_info.length > 0) {
                                lable += ': ';
                                item.additional_info.forEach((info, index) => {
                                  lable += `${info.chargableDays || 0} Days @ $${info.cost_per_unit} Per Kg`;
                                  if (index < item.additional_info.length - 1) {
                                    lable += ', ';
                                  }
                                });
                              }
                              return (
                                <Stack key={index} direction='row' spacing={3} alignItems='flex-start' justifyContent={'space-between'} width='100%'>
                                  <Typography variant='inherit'>{item.key + lable}</Typography>
                                  <Stack direction='row' spacing={1} alignItems='flex-start' justifyContent={'space-between'} className={notificationStyles.amount}>
                                    <Typography variant='inherit'>$</Typography>
                                    <Typography variant='inherit'>{item.cost.toFixed(2)}</Typography>
                                  </Stack>
                                </Stack>
                              );
                            })}
                          </Stack>
                        </TableCell>
                        <TableCell ref={props.columnRef.add_icon} width={40} align='center'
                          style={{ width: props.columnWidth?.add_icon }}
                          className={`${notificationStyles.collapsibleTableCell} ${notificationStyles.smallIcon}`}>
                          <EditIcon title='Add Additional Services' onClick={() => props.handleOpen('additional_services', null, row)} disabled={disablefields} />
                        </TableCell>
                        <TableCell ref={props.columnRef.consignee}
                          style={{
                            width: props.columnWidth?.consignee,
                            maxWidth: 300
                          }}
                          className={notificationStyles.collapsibleTableCell}>
                          <Stack direction='column' spacing={0.5}>
                            <Stack direction='row' spacing={2} alignItems='flex-start' justifyContent='space-between' className={`${notificationStyles.smallIcon}`}>
                              {
                                row.consigneeId ? (
                                  <Typography variant='inherit' mr={2} whiteSpace={'wrap'} color={row.house_awb === true ? 'error' : 'inherit'}>
                                    {row.consignee?.name}
                                  </Typography>
                                ) : row?.awb?.consignee ? (
                                  <Typography variant='inherit' mr={2} whiteSpace={'wrap'} color={row.house_awb === true ? 'error' : grey[500]} >
                                    {row?.awb?.consignee}
                                  </Typography>
                                ) : (
                                  <Typography
                                    variant='inherit'
                                    mr={2}
                                    color={'error'}
                                  >
                                    Select a Consignee
                                  </Typography>
                                )
                              }
                              {row.consigneeId ?
                                <DeleteIcon title='Remove Consignee' className={`${styles.actionIcons} ${notificationStyles.smallIcon} ${styles.p0} ${styles.pt1}`} disabled={props.showReportModal || disablefields} onClick={() => props.handleDeleteConsignee(row.id)} /> :
                                <EditIcon title='Update Consignee' className={`${styles.actionIcons} ${notificationStyles.smallIcon} ${styles.p0} ${styles.pt1}`} disabled={props.showReportModal || disablefields} onClick={(e) => props.openConsigneeModal(e, row)} />
                              }
                            </Stack>
                            {
                              row.consigneeId && row?.consignee && row?.consignee.email &&
                              <Tooltip title={row?.consignee?.email || ''} arrow>
                                <Typography variant='inherit' component='div' whiteSpace={'wrap'} className={notificationStyles.emailEllipsis}>
                                  {row?.consignee?.email}
                                </Typography>
                              </Tooltip>
                            }
                            {
                              row.consigneeId && row?.consignee?.mails && row?.consignee.mails.length > 0 ? (
                                row?.consignee?.mails.map((item, index) => (
                                  <Tooltip key={index} title={item?.email || ''} arrow>
                                    <Typography variant='inherit' component='div' className={notificationStyles.emailEllipsis}>
                                      {item?.email}
                                    </Typography>
                                  </Tooltip>
                                ))
                              ) : null
                            }
                          </Stack>
                        </TableCell>
                        <TableCell ref={props.columnRef.action}
                          style={{ width: props.columnWidth?.action }} className={notificationStyles.collapsibleTableCell}>
                          <Stack direction='row' spacing={1} justifyContent='flex-end' className={styles.actionIcons} mt={'2px'}>
                            <IconButton className={`${notificationStyles.addNotes} ${styles.p0} 
                            ${row.next || !row.consigneeId || disablefields ? styles.disabledImg : row?.notifications && row?.notifications.length > 0 ? styles.greenSvg : row.consigneeId ? '' : styles.disabledImg}`}
                            disabled={row.next || !row.consigneeId || disablefields} onClick={() => props.handleNotification(row)}>
                              <img src={SendIcon} alt='send' />
                            </IconButton>
                            <TableBadge badgeContent={row?.notifications?.length} color='error'>
                              <Button title='History' size='small' disabled={row.house_awb === true} disableElevation variant='contained' color='primary' className={notificationStyles.historyIcon} onClick={() => props.handleOpen('notification_history', false, row?.notifications || [])}>H</Button>
                            </TableBadge>
                          </Stack>
                        </TableCell>
                      </TableRow>

                      {row?.house_awbs.length > 0 &&
                        <TableRow className={`${notificationStyles.spRow}`}>
                          <TableCell colSpan={8} className={`${styles.p0} ${[styles.w100]}`}>
                            <Collapse in={true} timeout='auto' unmountOnExit>
                              <Box className={notificationStyles.collapsibleBox}>
                                <Table aria-label='' className={notificationStyles.collapsedTable}>
                                  <TableBody className={notificationStyles.collapsedTableBody}>
                                    {row?.house_awbs?.map((nestedRow, index) => {
                                      const hAwbData = getAwbDetails({
                                        ...nestedRow,
                                        flight: row?.flight
                                      });
                                      const hFees = calculateFees(nestedRow?.fee || [], {
                                        ...hAwbData,
                                        flight: row?.flight
                                      });
                                      let hStorage_start = null;
                                      if (nestedRow?.fee && nestedRow?.fee.length > 0) {
                                        let storage = null;
                                        nestedRow?.fee.forEach((fee) => {
                                          fee?.value?.forEach((value) => {
                                            if (value.unit === 'kg_per_day') {
                                              storage = value;
                                            }
                                          });
                                        });
                                        if (storage) {
                                          let storgae_info = getFee(storage, nestedRow?.fee, hAwbData, true);
                                          hStorage_start = storgae_info?.storage_start || null;
                                        }
                                      }
                                      return (
                                        <TableRow key={index} className={`${notificationStyles.collapsedTableRow} ${notificationStyles.selectedRow}`} onClick={() => props.fetchDocs(nestedRow)}>
                                          <TableCell style={{ width: props.columnWidth?.radio_btn }} className={notificationStyles.collapsedTableCell} >
                                            <Radio size='small' className={styles.p0}
                                              checked={props.activeAWB?.id === nestedRow?.id}
                                            />
                                          </TableCell>
                                          <TableCell className={notificationStyles.collapsedTableCell} style={{
                                            minWidth: props.columnWidth.radio_btn,
                                            maxWidth: props.columnWidth.radio_btn,
                                          }}></TableCell>
                                          <TableCell className={notificationStyles.collapsedTableCell} style={{
                                            minWidth: props.columnWidth.awb_no,
                                            maxWidth: props.columnWidth.awb_no,
                                          }}>
                                            <Stack direction='column' spacing={1} alignItems='flex-start'>
                                              <Typography variant='inherit'>
                                                {`${hAwbData.awb_no} | ${hAwbData.pcs}Pcs | ${hAwbData.wgt}K | ${hAwbData.org} - ${hAwbData.dest}`}
                                              </Typography>
                                              <Typography variant='inherit' whiteSpace={'break-spaces'}><b>Commodity : </b>{awbData.remark}</Typography>
                                            </Stack>
                                          </TableCell>
                                          <TableCell ref={props.columnRef.add_icon} width={40}
                                            style={{ width: props.columnWidth?.add_icon }}
                                            className={`${notificationStyles.collapsedTableCell}`}>
                                          </TableCell>
                                          <TableCell className={notificationStyles.collapsedTableCell} align='center' style={{
                                            maxWidth: props.columnWidth.storage_start,
                                            minWidth: 140
                                          }}>{hStorage_start ? moment(hStorage_start).format(DateFormat).toUpperCase() : ''}</TableCell>
                                          <TableCell className={notificationStyles.collapsedTableCell}
                                            style={{
                                              maxWidth: props.columnWidth?.fee,
                                              minWidth: props.columnWidth?.fee,
                                            }}
                                          >
                                            <Stack direction='column' spacing={1} alignItems='flex-start'>
                                              {hFees.services.map((item, index) => {
                                                let lable = '';
                                                if (item.additional_info && item.additional_info.length > 0) {
                                                  lable += ': ';
                                                  item.additional_info.forEach((info, index) => {
                                                    lable += `${info.chargableDays || 0} Days @ $${info.cost_per_unit} Per Kg`;
                                                    if (index < item.additional_info.length - 1) {
                                                      lable += ', ';
                                                    }
                                                  });
                                                }
                                                return (
                                                  <Stack key={index} direction='row' spacing={3} alignItems='flex-start' justifyContent={'space-between'} width='100%'>
                                                    <Typography variant='inherit'>{item.key + lable}</Typography>
                                                    <Stack direction='row' spacing={1} alignItems='flex-start' justifyContent={'space-between'} className={notificationStyles.amount}>
                                                      <Typography variant='inherit'>$</Typography>
                                                      <Typography variant='inherit'>{item.cost.toFixed(2)}</Typography>
                                                    </Stack>
                                                  </Stack>
                                                );
                                              })}
                                            </Stack>
                                          </TableCell>
                                          <TableCell align='center' style={{
                                            minWidth: props.columnWidth?.add_icon,
                                            maxWidth: props.columnWidth?.add_icon
                                          }} className={`${notificationStyles.collapsedTableCell} ${notificationStyles.smallIcon}`}>
                                            <AddIcon title='Add Additional Services' onClick={() => props.handleOpen('additional_services', null, {
                                              ...nestedRow,
                                              flight: row?.flight
                                            })} disabled={disablefields} />
                                          </TableCell>
                                          <TableCell className={notificationStyles.collapsedTableCell}
                                            style={{
                                              minWidth: props.columnWidth?.consignee,
                                              maxWidth: props.columnWidth?.consignee
                                            }}>
                                            <Stack direction='column' spacing={0.5}>
                                              <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between' className={`${notificationStyles.smallIcon}`}>
                                                {
                                                  nestedRow.consigneeId ? (
                                                    <Typography variant='inherit' mr={2} color='inherit'>
                                                      {nestedRow.consignee?.name}
                                                    </Typography>
                                                  ) : row?.awb?.consignee ? (
                                                    <Typography variant='inherit' mr={2} color='inherit'>
                                                      {row?.awb?.consignee}
                                                    </Typography>
                                                  ) : (
                                                    <Typography
                                                      variant='inherit'
                                                      mr={2}
                                                      color={'error'}
                                                    >
                                                      Select a Consignee
                                                    </Typography>
                                                  )
                                                }
                                                <EditIcon title='Update Consignee' className={`${styles.actionIcons} ${notificationStyles.smallIcon} ${styles.p0}`} disabled={props.showReportModal || disablefields} onClick={(e) => props.openConsigneeModal(e, nestedRow)} />
                                              </Stack>
                                              {
                                                nestedRow.consigneeId && nestedRow?.consignee?.mails && nestedRow?.consignee.mails.length > 0 ? (
                                                  nestedRow?.consignee?.mails.map((item, index) => (
                                                    <Tooltip key={index} title={item?.email || ''} arrow>
                                                      <Typography variant='inherit' component='div' className={notificationStyles.emailEllipsis}>
                                                        {item?.email}
                                                      </Typography>
                                                    </Tooltip>
                                                  ))
                                                ) : null
                                              }
                                            </Stack>
                                          </TableCell>
                                          <TableCell className={notificationStyles.collapsedTableCell} width={props.columnWidth?.action}>
                                            <Stack direction='row' spacing={1} justifyContent='center' className={styles.actionIcons}>
                                              <IconButton className={`${notificationStyles.addNotes} ${styles.p0}  
                                              ${nestedRow.next === true || !nestedRow.consigneeId || disablefields ? styles.disabledImg : nestedRow?.notifications && nestedRow?.notifications.length > 0 ? styles.greenSvg : row.consigneeId ? '' : styles.disabledImg}`}
                                              disabled={!nestedRow.consigneeId || disablefields}
                                              onClick={() => props.handleNotification({
                                                ...nestedRow,
                                                flight: row?.flight,
                                                awb: row?.awb
                                              })}>
                                                <img src={SendIcon} alt='send' />
                                              </IconButton>
                                              <TableBadge badgeContent={nestedRow?.notifications?.length} color='error'>
                                                <Button size='small' title='History' disableElevation variant='contained' color='primary' className={notificationStyles.historyIcon} onClick={() => props.handleOpen('notification_history', false, nestedRow?.notifications || [])}>H</Button>
                                              </TableBadge>
                                            </Stack>
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      }
                      {props.collapseViewer.includes(row.id) &&
                        <TableRow className={`${notificationStyles.spRow} ${notificationStyles.docViewerTabView}`}
                          sx={{ display: { xl: 'none' } }}>
                          <TableCell colSpan={8} className={styles.p0}>
                            <Collapse in={props.collapseViewer.includes(row.id)} timeout='auto' unmountOnExit>
                              <Box className={notificationStyles.collapsibleBox}>
                                {DocViewer}
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      }
                    </Fragment>;
                  })}
                </TableBody>
              </Table>
            </StyledTableContainer>
          </StyledCard>
        </Grid>

        <Grid item xs={4} className={`${notificationStyles.docViewer} ${notificationStyles.desktopDocViewer}`} sx={{
          display: {
            sm: 'none',
            xl: 'block',
          },
        }}>
          {DocViewer}
        </Grid>
      </Grid>

      {props.popover === 'status_history' &&
      <Popover
        open={props.popover== 'status_history'}
        anchorEl={props.popoverAnchorEl}
        onClose={props.handlePopoverClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}>
        <PopoverContent className={notificationStyles.popoverContent}>
          {props.popoverData.map((status, index) => (
            <Box component='div' key={index} p={1}>
              <Typography variant='inherit' component='span' color={status.color || 'primary'} className={notificationStyles.customStatus}>
                {status.dispositionCode}
              </Typography>
              <Typography variant='caption' color='textSecondary' fontWeight={700}>
                {moment(`${status?.dispositionActionDate || ''} ${status?.dispositionActionTime || ''}`, 'MMDDYY HHmmss').format('DDMMMYY hh:mm:ss').toUpperCase()}
              </Typography>
              {status?.hawbNumber && (
                <Typography variant='caption' component='div' color='primary' fontWeight={600} mb={'12px'}>
                  {`HAWB-${status.hawbNumber} `}
                </Typography>
              )}
              {status?.name && (
                <Typography variant='body2' component='div' color={'primary'}>
                  <span className={notificationStyles.customStatusDesc}>Name</span> 
                  {status?.name || ''}
                </Typography>
              )}
              <Typography variant='body2' component='div' color={'primary'}>
                <span className={notificationStyles.customStatusDesc}>Description</span> 
                {status?.description || 'Description Not Available'}
              </Typography>
              <Divider sx={{ mt: 2 }} />
            </Box>
          ))}
        </PopoverContent>
      </Popover>}

      {props.modal === 'add_house_awb' &&
        <AddHouseAwbModal
          modal={props.modal}
          anchorEl={props.anchorEl}
          data={props.modalData}
          handleOpen={props.handleOpen}
          handleClose={props.handleClose}
          submitHouseAwb={props.submitHouseAwb}
          onChangeHouseAwb={props.onChangeHouseAwb}
          houseAwbFields={props.houseAwbFields}
          houseAwbErrors={props.houseAwbErrors}
          addHouseAwb={props.addHouseAwb}
          onEditHouseAwb={props.onEditHouseAwb}
          onDeleteHouseAwb={props.onDeleteHouseAwb}
          handlePopoverOpen={props.handlePopoverOpen}
          handlePopoverClose={props.handlePopoverClose}
          popover={props.popover}
          popoverAnchorEl={props.popoverAnchorEl}
          popoverData={props.popoverData}
          editHouseAwb={props.editHouseAwb}
        />
      }

      {props.modal === 'update_consignee' &&
        <UpdateConsigneeModal
          modal={props.modal}
          handleClose={props.handleClose}
          consignees={props.consignees}
          onSelectedConsignee={props.onSelectedConsignee}
          selectedConsignee={props.selectedConsignee}
          consigneeFields={props.consigneeFields}
          consigneeOperation={props.consigneeOperation}
          addNewButtonHandler={props.addNewButtonHandler}
          consigneeSearch={props.consigneeSearch}
          onConsigneeSearch={props.onConsigneeSearch}
          handleassignConsignee={props.handleassignConsignee}
          editConsignee={props.editConsignee}
          onConsigneeFieldsChange={props.onConsigneeFieldsChange}
          onAddCMail={props.onAddCMail}
          onDeleteCMail={props.onDeleteCMail}
          onConsigneeMailChange={props.onConsigneeMailChange}
          consigneeFieldsErrors={props.consigneeFieldsErrors}
        />
      }

      {props.modal === 'additional_services' &&
        <AddAdditionalServicesModal
          modal={props.modal}
          handleClose={props.handleClose}
          handleChange={props.handleChange}
          services={props.services}
          data={props.modalData}
          serviceFields={props.serviceFields}
          serviceErrors={props.serviceErrors}
          handleChanegOperation={props.handleChanegOperation}
          onSubmitService={props.onSubmitService}
          onDeleteService={props.onDeleteService}
          showReportModal={props.showReportModal}
        />
      }
      {props.modal === 'send_notification' &&
        <SendNotificationModal
          modal={props.modal}
          handleClose={props.handleClose}
          data={props.modalData}
          handleSubmitNotification={props.handleSubmitNotification}
          showReportModal={props.showReportModal}
        />
      }
      {props.modal === 'notification_history' &&
        <NotificationHistoryModal
          modal={props.modal}
          handleClose={props.handleClose}
          data={props.modalData}
          showReportModal={props.showReportModal}
          activeAWB={props.activeAWB}
        />
      }
      {props.modal === 'part_arrival_info' &&
        <PartArrivalInfo
          popover={props.modal}
          anchorEl={props.anchorEl}
          data={props.modalData}
          partNotification={props.partNotification}
          onClose={props.handleClose}
        />
      }

      {props.modal === 'add_doc' &&
        <AddDocModal
          modal={props.modal}
          handleClose={props.handleClose}
          errors={props.docErrors}
          onChange={props.onChangeDoc}
          onSubmit={props.addDoc}
          // onSubmitReq={this.onSubmitReq}
          fileType={props.fileType}
          addDocType={props.addDocType}
          attachTo={props.attachTo}
          onhandleChange={props.onChangeDoc}
          fields={props.docfields}
        />
      }

    </>
  );
};

export default ImportNotification;

